import(/* webpackMode: "eager", webpackExports: ["ProductsGridContainer"] */ "/vercel/path0/apps/portals/src/app/[portalSlug]/(main)/products/container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portals/src/components/AppPage/AppPage.tsx");
